import { createSlice } from '@reduxjs/toolkit';

const toastMessageSlice = createSlice({
    name: "toastMessage",
    initialState: {
        toastMessageState: {
            open: false,
            type: 1,
            transMessage: '',
            message: '',
            autoHideDuration: 1500
        }
    },
    reducers: {
        setToastMessage: (state, action) => {
            state.toastMessageState = {
                ...state.toastMessageState,
                ...action.payload.toastMessageState
            };
        },
        closeToast: (state) => {
            state.toastMessageState = {
                open: false,
                type: 1,
                transMessage: '',
                message: '',
                autoHideDuration: 1500
            };
        }
    }
});

export const { setToastMessage, closeToast } = toastMessageSlice.actions;
export default toastMessageSlice.reducer;
